var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"te-footer"},[_c('div',{staticClass:"text-center co-text-gray-3 co-py-20"},[_c('small',[_vm._v("©2009 - "+_vm._s(new Date().getFullYear())+" KiRAMEX  "),_c('span',{staticClass:"d-none d-sm-inline-block"},[_vm._v("CORPORATION.")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }